import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { BrandLogo } from "../components/BrandName";
import SEO from "../components/SEO";

export default function AboutPage() {
  return (
    <main data-testid="about-page">
      <SEO
        title="About — Our Story | Unsere Geschichte"
        path="/about"
        description="Padlr. is a premium padel lifestyle brand designed in Switzerland. Better Than Yesterday. | Premium Padel Lifestyle Marke, designed in Switzerland. Besser als gestern."
      />
      {/* Hero */}
      <section className="relative pt-32 sm:pt-40 pb-16 sm:pb-24 bg-[#FDFDFD]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs tracking-[0.25em] uppercase text-[#8B6F47] mb-4">
            Our Story
          </p>
          <h1
            data-testid="about-page-heading"
            className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#0A0A0A] mb-4"
          >
            Better Than Yesterday.
          </h1>
          <p className="text-lg sm:text-xl text-[#888] tracking-wide">
            Born in Switzerland. Built for the Court.
          </p>
        </div>
      </section>

      {/* Image */}
      <section className="bg-[#FDFDFD]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1673266893352-6de89e258064?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwYWRlbCUyMGNvdXJ0JTIwZ2xhc3MlMjB3YWxscyUyMG5pZ2h0JTIwbGlnaHRzfGVufDB8fHx8MTc3NzYyMzYyMHww&ixlib=rb-4.1.0&q=85"
              alt="Padel court at night"
              className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
            />
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 sm:py-24 bg-[#FDFDFD]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-24">
            <div>
              <h2 className="text-2xl sm:text-3xl tracking-tighter text-[#0A0A0A] mb-6">
                The <BrandLogo /> Philosophy
              </h2>
              <div className="space-y-5 text-[#555] leading-relaxed tracking-wide text-sm sm:text-base">
                <p>
                  <BrandLogo color="#555" /> is for the ones who refuse to stay the same. The ones
                  who show up every day — on the court, in the gym, at work, in life — and
                  push to be better than they were yesterday. That mindset is what drives
                  everything we build.
                </p>
                <p>
                  We're not just a padel brand. We're a mindset. Whether you're chasing a
                  better backhand or a better version of yourself, <BrandLogo color="#555" /> is
                  built for the journey.
                </p>
              </div>
            </div>
            <div>
              <h2 className="text-2xl sm:text-3xl tracking-tighter text-[#0A0A0A] mb-6">
                Court to Street
              </h2>
              <div className="space-y-5 text-[#555] leading-relaxed tracking-wide text-sm sm:text-base">
                <p>
                  Our performance line is built with top-quality technical fabrics sourced
                  from the same manufacturers that supply the world's leading sports brands.
                  Lightweight, moisture-wicking, and engineered to move with you through
                  the most intense sessions on the court.
                </p>
                <p>
                  Off the court, our lifestyle collection features premium cotton pieces
                  designed for the look and the feel — because the game doesn't stop when
                  you step off the glass. Two lines, one philosophy: be better than yesterday.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-16 sm:mt-24 text-center">
            <Link
              to="/shop"
              data-testid="about-shop-cta"
              className="inline-block bg-[#0A0A0A] text-white px-12 py-4 text-xs tracking-[0.2em] uppercase hover:bg-[#1a1a1a] transition-colors active:scale-95"
              style={{ fontStyle: "normal" }}
            >
              See What's Coming
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
